import { DocumentStatus } from './models/document';
import { OrderStatus, OrderType } from './models/order';
import { PaymentMethod, PaymentRequestStatus } from './models/payment';
import { UserCategory, UserType } from './models/user';

export const USER_CATEGORIES: Array<UserCategory> = [
  'JAPAN',
  'NON_JAPAN',
  'INDIAN',
  'ELECTRICAL',
  'BEARING',
];
export const USER_ROLES: UserType[] = ['ADMIN', 'REP'];
export const DOCUMENT_STATUSES: DocumentStatus[] = ['PROCESSING', 'DRAFT', 'PUBLISHED', 'FAILED'];
export const ORDER_STATUSES: OrderStatus[] = ['PENDING', 'APPROVED', 'REJECTED', 'CANCELLED'];
export const ORDER_TYPES: OrderType[] = ['ORDER', 'REQUEST'];
/** Orders only ever belong to these three, not the full {@link USER_CATEGORIES} set. */
export const ORDER_CATEGORIES: UserCategory[] = ['JAPAN', 'NON_JAPAN', 'INDIAN'];
export const PAYMENT_STATUSES: PaymentRequestStatus[] = ['PENDING', 'ACCEPTED', 'REJECTED'];
export const PAYMENT_METHODS: PaymentMethod[] = ['CASH', 'CHEQUE', 'BANK_TRANSFER', 'OTHER'];
/** Labels for the payment methods; the raw enum names read badly in a dropdown. */
export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  CASH: 'Cash',
  CHEQUE: 'Cheque',
  BANK_TRANSFER: 'Bank Transfer',
  OTHER: 'Other',
};
// keep in sync with spring.servlet.multipart.max-file-size on the server
export const MAX_PDF_SIZE_BYTES = 50 * 1024 * 1024;
export const LK_PHONE_REGEX =
  '^(?:0|94|\\+94|0094)?(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|91)([0234579])|7([01245678])\\d)\\d{6}$';
